/**
 * Universal empty/null check utility - copied from main B18 app
 * Checks if a value is empty, null, undefined, or has no content
 */
export const isEmptyCheck = (value: any): boolean => {
  if (value === null || value === undefined || value === false) {
    return true
  }
  if (typeof value?.getMonth === 'function') {
    return false
  }
  if (typeof value === 'number') {
    return value === 0
  }
  if (typeof value === 'string') {
    return value.trim().length === 0
  }
  if (Array.isArray(value)) {
    return value.length === 0
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0
  }
  return !value
}
